import type { HelpFile } from '../../types/help'
import { SqlAssistPanelTestIds } from '../../../testids/SqlAssistPanelTestIds'

export const sqlAssistPanelHelp: HelpFile = {
  docPage: '/docs/reporting/sql-assist',
  texts: {
    [SqlAssistPanelTestIds.btnToggleAssist]:
      'Das KI-gestützte SQL-Assistenz-Panel neben dem Editor ein- oder ausblenden.',
    [SqlAssistPanelTestIds.inputAssistRequest]:
      'In natürlicher Sprache beschreiben, was das SQL leisten soll — der Assistent erzeugt daraus eine Abfrage gegen das IAM-Schema.',
    [SqlAssistPanelTestIds.selectModel]:
      'Sprachmodell auswählen, das die SQL-Empfehlung erzeugt. Verschiedene Modelle können unterschiedliche Stile oder Genauigkeiten liefern.',
    [SqlAssistPanelTestIds.btnSuggestSql]:
      'Die Anfrage an das gewählte Modell senden und einen SQL-Vorschlag erzeugen.',
    [SqlAssistPanelTestIds.suggestedSqlPreview]:
      'Schreibgeschützte Vorschau des vom Assistenten gelieferten SQL-Statements. Vor der Übernahme in den Editor sorgfältig prüfen.',
    [SqlAssistPanelTestIds.btnApplySuggestion]:
      'Den Inhalt des SQL-Editors durch den vorgeschauten Vorschlag ersetzen.',
  },
}
